// @vendors
const moment = require('moment');

// @helpers
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @actions
const signaturePatternActions = require('actions/signaturePattern');

// @constants
const {
    DATE_FORMAT_API, CHARGE_ACCOUNT_PREFIX,
    BROKER_DERIVATIVES_MOVEMENTS_UPDATE_SIGNATURE_PATTERN
} = require('constants/index');

const {
    BROKER_TRANSFER_OF_DERIVATIVES_SET_ORIGIN_CONTRACT,
    BROKER_TRANSFER_OF_DERIVATIVES_FETCHING,
    BROKER_TRANSFER_OF_DERIVATIVES_FETCHING_SUCCESS,
    BROKER_TRANSFER_OF_DERIVATIVES_FETCHING_ERROR,
    BROKER_TRANSFER_OF_DERIVATIVES_MODIFY,
    BROKER_TRANSFER_OF_DERIVATIVES_REMOVE,
    BROKER_TRANSFER_OF_DERIVATIVES_REMOVE_SUCCESS,
    BROKER_TRANSFER_OF_DERIVATIVES_REMOVE_ERROR,
    BROKER_TRANSFER_OF_DERIVATIVES_CHANGE_AMOUNT,
    BROKER_TRANSFER_OF_DERIVATIVES_MODIFY_CHANGE_CONCEPT,
    BROKER_TRANSFER_OF_DERIVATIVES_VALIDATE,
    BROKER_TRANSFER_OF_DERIVATIVES_SAVE,
    BROKER_TRANSFER_OF_DERIVATIVES_SAVE_SUCCESS,
    BROKER_TRANSFER_OF_DERIVATIVES_SAVE_ERROR,
    BROKER_TRANSFER_OF_DERIVATIVES_CANCEL,
    BROKER_TRANSFER_OF_DERIVATIVES_TOGGLE_DELETE_MODAL
} = require('constants/actionTypes');

const setOriginContract = (contractNumber) => (dispatch) => dispatch({
    type: BROKER_TRANSFER_OF_DERIVATIVES_SET_ORIGIN_CONTRACT,
    payload: { contractNumber }
});

const validateSignaturePattern = (dispatch, getState, onSuccess, onError) => {
    signaturePatternActions.validateAndExecute(dispatch, getState, onSuccess).catch(
        (error) => onError(error)
    );
};

const fetchSuccess = (response) => ({
    type: BROKER_TRANSFER_OF_DERIVATIVES_FETCHING_SUCCESS,
    payload: { response }
});

const fetchError = (error) => ({
    type: BROKER_TRANSFER_OF_DERIVATIVES_FETCHING_ERROR,
    payload: { error }
});

const fetch = () => (dispatch, getState) => {
    const immBrokerDerivativesMovements = getState().brokerDerivativesMovements;
    const originContractNumber = immBrokerDerivativesMovements.get('originContractNumber');

    const immOriginFuture = getState().brokerWallets.get('futuresList').find(
        immFuture => immFuture.getIn(['cviejo', 'numerodecontrato']) === originContractNumber
    );

    if (!immOriginFuture) {
        return;
    }

    const url = apiURLBuilder.getURL('futurosTraspasos');

    const requestData = {
        subgrupoViejo: immOriginFuture.getIn(['cviejo', 'subgrupo']),
        numeroContratoViejo: originContractNumber
    };

    dispatch({
        type: BROKER_TRANSFER_OF_DERIVATIVES_FETCHING,
        payload: {}
    });

    APIGet(dispatch, url, { query: requestData }).then(
        (response) => dispatch(fetchSuccess(response)),
        (error) => dispatch(fetchError(error))
    );
};

const modify = () => (dispatch) => dispatch({
    type: BROKER_TRANSFER_OF_DERIVATIVES_MODIFY,
    payload: {}
});

const removeSuccess = (response) => ({
    type: BROKER_TRANSFER_OF_DERIVATIVES_REMOVE_SUCCESS,
    payload: { response }
});

const removeError = (error) => ({
    type: BROKER_TRANSFER_OF_DERIVATIVES_REMOVE_ERROR,
    payload: { error }
});

const onValidRemoveSignaturePattern = (dispatch, getState, token) => {
    const immBrokerDerivativesMovements = getState().brokerDerivativesMovements;
    const originContractNumber = immBrokerDerivativesMovements.get('originContractNumber');

    const immOriginFuture = getState().brokerWallets.get('futuresList').find(
        immFuture => immFuture.getIn(['cviejo', 'numerodecontrato']) === originContractNumber
    );

    if (!immOriginFuture) {
        return;
    }

    const url = apiURLBuilder.getURL('futurosTraspasoBajaConfirmacion');

    const requestData = {
        contratoViejo: {
            subgrupoViejo: immOriginFuture.getIn(['cviejo', 'subgrupo']),
            numeroContratoViejo: originContractNumber
        },
        dataToken: token,
        fecha: moment(immBrokerDerivativesMovements.get('creationDate')).format(DATE_FORMAT_API)
    };

    APIGet(dispatch, url, { query: requestData }).then(
        (response) => dispatch(removeSuccess(response)),
        (error) => dispatch(removeError(error))
    );
};

const remove = () => (dispatch, getState) => {
    const immBrokerDerivativesMovements = getState().brokerDerivativesMovements;

    const signaturePatternParams = {
        originAccount: immBrokerDerivativesMovements.getIn(['originAccount', 'number']),
        destinationAccount: immBrokerDerivativesMovements.getIn(['destinationAccount', 'number'])
    };

    dispatch({
        type: BROKER_TRANSFER_OF_DERIVATIVES_REMOVE,
        payload: {}
    });

    dispatch(signaturePatternActions.processRequestConfiguration(BROKER_DERIVATIVES_MOVEMENTS_UPDATE_SIGNATURE_PATTERN, signaturePatternParams)).then(
        () => validateSignaturePattern(
            dispatch,
            getState,
            onValidRemoveSignaturePattern,
            (error) => dispatch(removeError(error))
        ),
        (error) => dispatch(removeError(error))
    );
};

const changeAmount = (amount) => (dispatch) => dispatch({
    type: BROKER_TRANSFER_OF_DERIVATIVES_CHANGE_AMOUNT,
    payload: { amount }
});

const changeConcept = (concept) => (dispatch) => dispatch({
    type: BROKER_TRANSFER_OF_DERIVATIVES_MODIFY_CHANGE_CONCEPT,
    payload: { concept }
});

const saveSuccess = (response) => ({
    type: BROKER_TRANSFER_OF_DERIVATIVES_SAVE_SUCCESS,
    payload: { response }
});

const saveError = (error) => ({
    type: BROKER_TRANSFER_OF_DERIVATIVES_SAVE_ERROR,
    payload: { error }
});

const onValidUpdateSignaturePattern = (dispatch, getState, token) => {
    const immBrokerDerivativesMovements = getState().brokerDerivativesMovements;
    const originContractNumber = immBrokerDerivativesMovements.getIn(['originAccount', 'number']);

    const immOriginFuture = getState().brokerWallets.get('futuresList').find(
        immFuture => immFuture.getIn(['cviejo', 'numerodecontrato']) === originContractNumber
    );

    const url = apiURLBuilder.getURL('futurosTraspasoSalida');

    const requestData = {
        concepto: immBrokerDerivativesMovements.get('concept'),
        contratoViejo: {
            numerodecontrato: immBrokerDerivativesMovements.getIn(['originAccount', 'number']),
            subgrupo: immOriginFuture.getIn(['cviejo', 'subgrupo'])
        },
        dataToken: token,
        fecha: moment(immBrokerDerivativesMovements.get('creationDate')).format(DATE_FORMAT_API),
        importeCuenta: {
            divisa: immBrokerDerivativesMovements.get('amountToTransferCurrency'),
            importe: immBrokerDerivativesMovements.get('amountToTransfer')
        }
    };

    APIPost(dispatch, url, { query: requestData }).then(
        (response) => dispatch(saveSuccess(response)),
        (error) => dispatch(saveError(error))
    );
};

const validate = () => ({
    type: BROKER_TRANSFER_OF_DERIVATIVES_VALIDATE,
    payload: {}
});

const save = () => (dispatch, getState) => {
    dispatch(validate());

    const immBrokerDerivativesMovements = getState().brokerDerivativesMovements;

    if (!immBrokerDerivativesMovements.get('valid')) {
        return;
    }

    const originAccountNumber = immBrokerDerivativesMovements.getIn(['originAccount', 'number']);
    const destinationAccountNumber = immBrokerDerivativesMovements.getIn(['destinationAccount', 'number']);

    const immOriginFuture = getState().brokerWallets.get('futuresList').find(
        immFuture => immFuture.getIn(['cviejo', 'numerodecontrato']) === originAccountNumber
    );

    const immDestinationFuture = getState().brokerWallets.get('futuresList').find(
        immFuture => immFuture.getIn(['cviejo', 'numerodecontrato']) === destinationAccountNumber
    );

    const originProduct = immOriginFuture.getIn(['cviejo', 'subgrupo']);
    const destinationProduct = immDestinationFuture.getIn(['cviejo', 'subgrupo']);

    const signaturePatternParams = {
        originAccount: `${CHARGE_ACCOUNT_PREFIX}${originProduct}${originAccountNumber}`,
        destinationAccount: `${CHARGE_ACCOUNT_PREFIX}${destinationProduct}${destinationAccountNumber}`
    };

    dispatch({
        type: BROKER_TRANSFER_OF_DERIVATIVES_SAVE,
        payload: {}
    });

    dispatch(
        signaturePatternActions.processRequestConfiguration(
            BROKER_DERIVATIVES_MOVEMENTS_UPDATE_SIGNATURE_PATTERN, signaturePatternParams
        )
    ).then(
        () => validateSignaturePattern(dispatch, getState, onValidUpdateSignaturePattern, (error) => dispatch(saveError(error))),
        (error) => dispatch(saveError(error))
    );
};

const cancel = () => (dispatch) => dispatch({
    type: BROKER_TRANSFER_OF_DERIVATIVES_CANCEL,
    payload: {}
});

const toggleDeleteModal = () => (dispatch) => dispatch({
    type: BROKER_TRANSFER_OF_DERIVATIVES_TOGGLE_DELETE_MODAL,
    payload: {}
});

module.exports = {
    setOriginContract,
    fetch,
    modify,
    remove,
    changeAmount,
    changeConcept,
    save,
    cancel,
    toggleDeleteModal
};
